import { useState, useEffect } from 'react';
import Orientation, { useDeviceOrientationChange, useOrientationChange, } from 'react-native-orientation-locker';
import { VALID_ORIENTATIONS } from '../../utils';
const isValidOrientation = (o) => VALID_ORIENTATIONS.includes(o);
export const useValidOrientations = () => {
    const [deviceOrientation, setDeviceOrientation] = useState(Orientation.getInitialOrientation());
    const [appOrientation, setAppOrientation] = useState();
    useEffect(() => {
        Orientation.getOrientation((o) => {
            setAppOrientation(o);
        });
        Orientation.getDeviceOrientation((o) => {
            setDeviceOrientation(o);
        });
    }, []);
    useDeviceOrientationChange((o) => {
        if (isValidOrientation(o)) {
            setDeviceOrientation(o);
        }
    });
    useOrientationChange((o) => {
        if (isValidOrientation(o)) {
            setAppOrientation(o);
        }
    });
    return {
        appOrientation,
        deviceOrientation,
    };
};
//# sourceMappingURL=useValidOrientations.js.map